import React from 'react';

import { PATH } from 'src/pages/account';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { SCREENS } from 'src/constants/screens';

const AccountRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/account')),
        title: 'account.page_title',
        screenId: SCREENS.R1009,
      },
    ],
  },
];

export default AccountRoute;
